<template>
  <div class="home" v-if="recipes">
    <div class="columns is-variable is-2 is-multiline is-mobile">
      <div class="column is-half-desktop is-full-tablet is-full-mobile">
        <CardLink size="large" :data="recipes[0]" type="recipe" />
        <div class="columns is-variable is-2 is-multiline is-mobile">
          <div class="column is-half-desktop is-full-tablet is-full-mobile">
            <CardLink size="small" :data="recipes[1]" type="recipe" />
            <CardLink size="small" :data="recipes[2]" type="recipe" />
            <CardLink size="medium" :data="recipes[3]" type="recipe" />
            <CardLink size="small" :data="recipes[4]" type="recipe" />
            <CardLink size="small" :data="recipes[5]" type="recipe" />
          </div>
          <div class="column is-half-desktop is-full-tablet is-full-mobile">
            <CardLink size="small" :data="recipes[6]" type="recipe" />
            <CardLink size="small" :data="recipes[7]" type="recipe" />
            <CardLink size="medium" :data="recipes[8]" type="recipe" />
            <CardLink size="small" :data="recipes[9]" type="recipe" />
            <CardLink size="small" :data="recipes[10]" type="recipe" />
          </div>
        </div>
      </div>
      <div class="column is-one-quarter-desktop is-half-tablet is-full-mobile">
        <CardLink size="medium" :data="recipes[11]" type="recipe" />
        <CardLink size="medium" :data="recipes[12]" type="recipe" />
        <CardLink size="small" :data="recipes[13]" type="recipe" />
        <CardLink size="medium" :data="recipes[14]" type="recipe" />
        <CardLink size="small" :data="recipes[15]" type="recipe" />
        <CardLink size="small" :data="recipes[16]" type="recipe" />
      </div>
      <div class="column is-one-quarter-desktop is-half-tablet is-full-mobile">
        <CardLink size="medium" :data="recipes[17]" type="recipe" />
        <CardLink size="medium" :data="recipes[18]" type="recipe" />
        <CardLink size="small" :data="recipes[19]" type="recipe" />
        <CardLink size="medium" :data="recipes[20]" type="recipe" />
        <CardLink size="small" :data="recipes[21]" type="recipe" />
        <CardLink size="small" :data="recipes[22]" type="recipe" />
      </div>
    </div>
  </div>
</template>

<style lang="sass">
@import "../styles/Home"
</style>

<script>
import CardLink from "../components/CardLink";

export default {
  components: { CardLink },
  async beforeCreate() {
    this.recipes = await this.$recipes.GetRandom();
  },
  data() {
    return {
      recipes: undefined
    }
  }
}
</script>
